export const DEFAULT_AVATAR =
  "https://mc-heads.net/avatar/9dde22a18d5f488fb48e849335b748e9/50";
